import React, { useEffect } from 'react';
import Localize from 'react-intl-universal';

import { get } from 'lodash-es';

// MUI
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import Logger from '@common/Logger.js';
import { createAdvancedFilters } from '@common/Util';
import NoContent from '@components/NoContentComponent/NoContent.jsx';
import RichTextEditor, { readStyledText } from '@components/RichTextEditor/RichTextEditor';
import useFetching from '@hooks/Fetching/Fetching.js';
import { getService } from '@services/axiosUtil.js';
import * as serviceConstants from '@services/Constants';

const StyledContainer = styled(Container, {
  shouldForwardProp: (prop) => prop !== 'minHeight'
})(({ minHeight }) => ({
  textAlign: 'left',
  overflow: 'auto',
  minHeight: minHeight
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: '2rem',
  backgroundColor: theme.palette.background.primary,
  boxShadow: 'none'
}));

const Notes = ({ eventId, advancedFilters, minHeight = '' }) => {
  const createNotesService = async (eventId) => {
    return getService(
      `${serviceConstants.MEA_SERVER_CONFIGURATION.resource.customerEventsNotes.replace(
        ':eventId',
        eventId
      )}` + (advancedFilters ? `?${createAdvancedFilters(advancedFilters)}` : ''),
      null,
      true,
      false
    );
  };

  const [notes, isLoadingNotes, , fetchNotes] = useFetching(
    createNotesService.bind(null, eventId),
    true
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (eventId) {
          fetchNotes();
        }
      } catch (e) {
        Logger.error(e);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventId]);

  const noteObject = get(notes, 'data.content[0]', {});
  const descriptionString = readStyledText(noteObject, 'text');

  return (
    <>
      <StyledContainer minHeight={minHeight}>
        {isLoadingNotes && (
          <Box display='flex' justifyContent='center' alignItems='center' height='100%'>
            <CircularProgress size={60} />
          </Box>
        )}

        {descriptionString ? (
          <StyledPaper elevation={3}>
            <Typography variant='h6' gutterBottom>
              {`${Localize.get('CustomerLoyaltyEvents.public')} ${Localize.get('ILTSession.note')}`}
            </Typography>
            <Box data-testid={'noteIsAvailable'}>
              <RichTextEditor initialValue={noteObject?.text} disabled isToolbarHidden />
            </Box>
          </StyledPaper>
        ) : (
          <Box data-testid={'noNotesMessage'}>
            <NoContent infoType={Localize.get('EventDetails.noNotesAvailable')} />
          </Box>
        )}
      </StyledContainer>
    </>
  );
};

export default Notes;
